import { Component } from 'react';
import debounce from 'lodash-es/debounce';
import cloneDeep from 'lodash-es/cloneDeep';
import { connect } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faCheckSquare } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-regular-svg-icons/faSquare';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';

import { fetchFilingsCategories } from '../../../../../actions/filings.actions';
import { filterByCategory, filterByAllCategory } from '../../../../../actions/filingsFilters.actions';
import DropdownRow from './DropdownRow';
import Preloader from '../../../../Preloader';
import withComponentName from '../../../../../decorators/withComponentName';

import StorageSvc from '../../../../../services/StorageSvc';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

class CategoriesFilingsDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabType: 'categories',
      isMenuOpen: false,
      selectedExpandRow: {},
      searchString: '',
      dropdown: {
        options: [],
      },
      rightSideOptions: [],
      typeOptions: [],
      dropdownTitle: '',
      isAllCategories: true,
      isAlltypes: true,
      showLoading: false,
    };
    autoBind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
    this.createTypeData = debounce(this.createTypeData, 250);
    const { fetchFilingsCategories: propsFetchFilingsCategories } = this.props;

    const presistedState = StorageSvc.getItem('FilingsCategoryFilter');
    if (presistedState !== null) {
      const rehydrate = JSON.parse(presistedState);
      // return if we get data from the local storage
      const dropdownTitle = rehydrate.isAllCategories
        ? 'All Categories & Types'
        : ((rehydrate.dropdown || {}).options || []).filter((f) => f.select).map((e) => e.name).join(', ');
      return this.setState({
        dropdown: rehydrate.dropdown,
        isAllCategories: rehydrate.isAllCategories,
        isAlltypes: rehydrate.isAlltypes,
        dropdownTitle,
      });
    }
    propsFetchFilingsCategories({ nested: true })
      .then((data) => {
        const {
          filing_category_ids: selecetdIds,
          filing_type_ids: selecetdTypeIds,
          isAllCategories,
          isAlltypes,
        } = this.props;
        const options = [];
        for (let i = 0; i < data.length; i += 1) {
          const currentData = data[i];
          const types = [];
          let selectTypeCount = 0;
          const isSelect = isAllCategories || selecetdIds.includes(currentData.id);
          for (let j = 0; j < (currentData.types || []).length; j += 1) {
            const currentType = currentData.types[j];
            const isTypeSelected = isSelect
              || isAlltypes || selecetdTypeIds.includes(currentType.id);
            if (isTypeSelected) {
              types.push({
                ...currentType,
                select: true,
              });
              selectTypeCount += 1;
            } else {
              types.push(currentType);
            }
          }
          options.push({
            ...currentData,
            types,
            select: isSelect || selectTypeCount,
            isSelectAll: isSelect,
          });
        }
        const dropdownTitle = isAllCategories
          ? 'All Categories & Types'
          : options.filter((f) => f.select).map((e) => e.name).join(', ');
        this.setState({
          dropdown: { options },
          isAllCategories,
          isAlltypes,
          dropdownTitle,
        });
      });
  }

  componentDidUpdate(prevProps) {
    const { isReset, isCategoryReset } = this.props;
    if ((isReset && isReset !== prevProps.isReset)
      || (isCategoryReset && isCategoryReset !== prevProps.isCategoryReset)) {
      const { dropdown } = this.state;
      const { options } = dropdown;
      const newOptions = options
        .map((rest) => ({
          ...rest,
          select: true,
          isSelectAll: true,
          types: (rest.types || []).map((restType) => ({ ...restType, select: true })),
        }));
      this.setState({
        dropdown: { options: newOptions },
        dropdownTitle: '',
        isAllCategories: true,
        isAlltypes: true,
      }, () => {
        const { token } = this.props;
        const { dropdown: stateDropdown, isAllCategories, isAlltypes } = this.state;
        if (!token) {
          StorageSvc.setItem(
            'FilingsCategoryFilter',
            JSON.stringify({ dropdown: stateDropdown, isAllCategories, isAlltypes }),
          );
        }
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(e) {
    const { isMenuOpen } = this.state;
    if (
      this.categoriesDropdown && !this.categoriesDropdown.contains(e.target)
      && e.target
      && isMenuOpen
    ) {
      this.setState({
        isMenuOpen: false,
        selectedExpandRow: {},
        tabType: 'categories',
      });
    }
  }

  handleDropdownHederClick() {
    const { isMenuOpen } = this.state;
    if (isMenuOpen) {
      return this.setState({
        isMenuOpen: false,
        selectedExpandRow: {},
        tabType: 'categories',
      });
    }
    return this.setState({
      isMenuOpen: true,
    });
  }

  handleTabChangeClick(e) {
    const tabName = e.target.dataset.name;
    const { dropdown, isAllCategories } = this.state;
    const { options } = dropdown;
    if (tabName === 'types') {
      this.setState({
        tabType: 'types',
        selectedExpandRow: {},
        showLoading: true,
      }, () => {
        this.createTypeData();
      });
    } else {
      const dropdownTitle = isAllCategories
        ? 'All Categories & Types'
        : options.filter((f) => f.select).map((f) => f.name).join(', ');
      this.setState({
        tabType: tabName,
        selectedExpandRow: {},
        typeOptions: [],
        dropdownTitle,
      });
    }
  }

  createTypeData() {
    const { dropdown, isAlltypes } = this.state;
    const { options } = dropdown;
    const typeOptions = [];
    for (let i = 0; i < options.length; i += 1) {
      const currentCategory = options[i];
      if ((currentCategory.types || []).length) {
        for (let j = 0; j < currentCategory.types.length; j += 1) {
          const currentType = currentCategory.types[j];
          const typeID = typeOptions.findIndex((f) => f.id === currentType.id);
          if (typeID === -1) {
            typeOptions.push({
              ...currentType,
              category_id: [currentCategory.id],
            });
          } else {
            typeOptions[typeID].category_id.push(currentCategory.id);
            typeOptions[typeID].select = typeOptions[typeID].select || currentType.select;
          }
        }
      }
    }
    const dropdownTitle = isAlltypes
      ? 'All Categories & Types'
      : typeOptions.filter((f) => f.select).map((f) => f.name).join(', ');
    this.setState({
      typeOptions,
      dropdownTitle,
      showLoading: false,
    });
  }

  handleSelectAllClick() {
    const {
      tabType, isAllCategories, isAlltypes, dropdown,
    } = this.state;
    const { piwikEnabled } = this.props;
    const { options } = dropdown;
    const {
      token,
      filterByAllCategory: propsFilterByAllCategory,
      filterByCategory: propsFilterByCategory,
    } = this.props;
    if (tabType === 'categories') {
      const newCategoryValue = !isAllCategories;
      // selecting all category will effect types
      const newOptions = options
        .map((rest) => ({
          ...rest,
          select: newCategoryValue,
          isSelectAll: newCategoryValue,
          types: (rest.types || []).map((restType) => ({ ...restType, select: newCategoryValue })),
        }));
      const dropdownTitle = !isAllCategories ? 'All Categories & Types' : '';
      this.setState({
        dropdownTitle,
        dropdown: { options: newOptions },
        isAllCategories: !isAllCategories,
        isAlltypes: !isAllCategories,
      }, () => {
        const {
          dropdown: stateDropdown,
          isAllCategories: stateIsAllCategories,
          isAlltypes: stateIsAlltypes,
        } = this.state;

        if (!token) {
          StorageSvc.setItem(
            'FilingsCategoryFilter',
            JSON.stringify({
              dropdown: stateDropdown,
              isAllCategories: stateIsAllCategories,
              isAlltypes: stateIsAlltypes,
            }),
          );
        }
      });
      propsFilterByAllCategory({
        filing_categories_all: !isAllCategories,
        filing_types_all: !isAllCategories,
      }, token);
    } else {
      const newTypeValue = !isAlltypes;
      const newOptions = options
        .map((rest) => {
          /*
            Check if categoty has the type or not
            if it has type then use the new calue true/false
            if not then check if all category is select or not
            if all category is not selected then use the old value by rest.select
          */
          const isTypeSelected = (rest.types || []).length
            ? newTypeValue : isAllCategories || rest.select;
          return {
            ...rest,
            select: isTypeSelected,
            isSelectAll: isTypeSelected,
            types: (rest.types || []).map((restType) => ({ ...restType, select: newTypeValue })),
          };
        });

      const selectedCategoryIds = newOptions
        .filter((f) => f.select)
        .map((e) => e.id);
      const dropdownTitle = !isAlltypes ? 'All Categories & Types' : '';
      const filingAllCategory = !isAlltypes
        ? selectedCategoryIds.length === newOptions.length : false;

      this.setState({
        dropdown: { options: newOptions },
        isAllCategories: filingAllCategory,
        isAlltypes: !isAlltypes,
        dropdownTitle,
      }, () => {
        this.createTypeData();
        const {
          dropdown: stateDropdown,
          isAllCategories: stateIsAllCategories,
          isAlltypes: stateIsAlltypes,
        } = this.state;

        if (!token) {
          StorageSvc.setItem(
            'FilingsCategoryFilter',
            JSON.stringify({
              dropdown: stateDropdown,
              isAllCategories: stateIsAllCategories,
              isAlltypes: stateIsAlltypes,
            }),
          );
        }
      });
      propsFilterByCategory({
        filing_categories_all: filingAllCategory,
        filing_types_all: !isAlltypes,
        filing_category_ids: selectedCategoryIds,
        filing_type_ids: [],
      }, token);
    }
    if (piwikEnabled) {
      _paq.push(['trackEvent', 'Filings', `categories selected/unselected all ${options}`]);
    }
  }

  handleExpandRowSelect(e, value, isRightSideMenuOpen) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isRightSideMenuOpen) {
      this.setState({
        selectedExpandRow: {},
        rightSideOptions: [],
      });
    } else {
      const { dropdown } = this.state;
      const { options } = dropdown;
      const foundIndex = options.findIndex((f) => f.id === value.id);
      if (foundIndex > -1) {
        const rightSideOptions = options[foundIndex].types || [];
        this.setState({
          rightSideOptions,
          selectedExpandRow: options[foundIndex],
        });
      }
    }
  }

  handleParentCheckboxClick(value, isAlreadySelected) {
    const { dropdown, selectedExpandRow } = this.state;
    const { options } = dropdown;
    const foundIndex = options.findIndex((f) => f.id === value.id);
    const newCategoryData = cloneDeep(options[foundIndex]);
    // If metch then we need to update right side state value.
    const isRightSideMatch = selectedExpandRow.id === value.id;
    if (isAlreadySelected) {
      newCategoryData.select = false;
      newCategoryData.isSelectAll = false;
      const rightSideOptions = (newCategoryData.types || [])
        .map((obj) => ({ ...obj, select: false }));
      if ((newCategoryData.types || []).length) {
        newCategoryData.types = rightSideOptions;
      }

      options[foundIndex] = newCategoryData;
      const dropdownTitle = options.filter((f) => f.select).map((f) => f.name).join(', ');
      this.setState({
        ...(isRightSideMatch ? { rightSideOptions } : {}), // Update state value.
        dropdownTitle,
        dropdown: { options },
        isAllCategories: false,
        isAlltypes: false,
      }, () => {
        this.saveState();
      });
    } else {
      newCategoryData.select = true;
      newCategoryData.isSelectAll = true;
      const rightSideOptions = (newCategoryData.types || [])
        .map((obj) => ({ ...obj, select: true }));
      if ((newCategoryData.types || []).length) {
        newCategoryData.types = rightSideOptions;
      }

      options[foundIndex] = newCategoryData;
      const selectedData = options.filter((f) => f.select);
      const isAllCategories = selectedData.length === options.length;
      const dropdownTitle = isAllCategories
        ? 'All Categories & Types'
        : selectedData.map((f) => f.name).join(', ');
      this.setState({
        ...(isRightSideMatch ? { rightSideOptions } : {}), // Update state value.
        isAllCategories,
        dropdownTitle,
        isAlltypes: isAllCategories,
        dropdown: { options },
      }, () => {
        this.saveState();
      });
    }
  }

  handleRowSelect(value, isAlreadySelected) {
    const { dropdown, rightSideOptions, selectedExpandRow } = this.state;
    const { options } = dropdown;
    const foundCategoryIndex = options.findIndex((f) => f.id === selectedExpandRow.id);
    const foundIndex = rightSideOptions.findIndex((f) => f.id === value.id);

    const newCategoryData = cloneDeep(options[foundCategoryIndex]);

    if (isAlreadySelected) {
      rightSideOptions[foundIndex].select = false;
      newCategoryData.isSelectAll = false;
      const isSomeSelected = rightSideOptions.some((s) => s.select);
      newCategoryData.select = isSomeSelected;
      newCategoryData.types = rightSideOptions;
      options[foundCategoryIndex] = newCategoryData;
      const dropdownTitle = options.map((f) => f.name).join(', ');
      /*
        If is all categories is true then pass the isSomeSelected value.
      */
      this.setState({
        rightSideOptions,
        dropdownTitle,
        dropdown: { options },
        selectedExpandRow: newCategoryData,
        isAllCategories: false,
        isAlltypes: false,
      }, () => {
        this.saveState();
      });
    } else {
      rightSideOptions[foundIndex].select = true;
      newCategoryData.select = true;
      const isNotSomeSelected = rightSideOptions.some((s) => !s.select);
      newCategoryData.isSelectAll = !isNotSomeSelected;
      newCategoryData.types = rightSideOptions;
      options[foundCategoryIndex] = newCategoryData;
      const isNotSomeSelectedCategory = options.some((s) => !s.isSelectAll);
      const dropdownTitle = !isNotSomeSelectedCategory
        ? 'All Categories & Types'
        : options.map((f) => f.name).join(', ');
      this.setState({
        rightSideOptions,
        dropdownTitle,
        isAllCategories: !isNotSomeSelectedCategory,
        isAlltypes: !isNotSomeSelectedCategory,
        dropdown: { options },
        selectedExpandRow: newCategoryData,
      }, () => {
        this.saveState();
      });
    }
  }

  handleTypeRowSelect(value, isAlreadySelected) {
    const { dropdown, typeOptions } = this.state;
    const { options } = dropdown;

    for (let i = 0; i < options.length; i += 1) {
      if (value.category_id.includes(options[i].id)) {
        const newCategoryData = cloneDeep(options[i]);
        const innerTypeIndex = newCategoryData.types.findIndex((f) => f.id === value.id);
        if (isAlreadySelected) {
          newCategoryData.isSelectAll = false;
          newCategoryData.types[innerTypeIndex].select = false;
          const isSomeSelected = newCategoryData.types.some((s) => s.select);
          newCategoryData.select = isSomeSelected;
        } else {
          newCategoryData.select = true;
          newCategoryData.types[innerTypeIndex].select = true;
          const isNotSomeSelected = newCategoryData.types.some((s) => !s.select);
          newCategoryData.isSelectAll = !isNotSomeSelected;
        }
        options[i] = newCategoryData;
      }
    }

    const foundIndex = typeOptions.findIndex((f) => f.id === value.id);
    if (isAlreadySelected) {
      typeOptions[foundIndex].select = false;
      const dropdownTitle = options.map((f) => f.name).join(', ');
      this.setState({
        typeOptions,
        dropdownTitle,
        dropdown: { options },
        isAllCategories: false,
        isAlltypes: false,
      }, () => {
        this.saveState();
      });
    } else {
      typeOptions[foundIndex].select = true;
      const isNotSomeSelected = options.some((s) => !s.isSelectAll);
      const dropdownTitle = !isNotSomeSelected
        ? 'All Categories & Types'
        : options.map((f) => f.name).join(', ');
      this.setState({
        typeOptions,
        dropdownTitle,
        isAllCategories: !isNotSomeSelected,
        isAlltypes: !isNotSomeSelected,
        dropdown: { options },
      }, () => {
        this.saveState();
      });
    }
  }

  handleSearch(e) {
    this.setState({
      searchString: e.target.value,
    });
  }

  handleMenuCloseEvent() {
    this.setState({
      isMenuOpen: false,
      selectedExpandRow: {},
      tabType: 'categories',
    });
  }

  handleMenuBackClickEvent(e) {
    e.stopPropagation();
    this.setState({
      selectedExpandRow: {},
    });
  }

  saveState() {
    const { token, filterByCategory: propsFilterByCategory, piwikEnabled, } = this.props;
    const { dropdown, isAllCategories, isAlltypes } = this.state;
    const { options } = dropdown;
    if (!token) {
      StorageSvc.setItem(
        'FilingsCategoryFilter',
        JSON.stringify({ dropdown, isAllCategories, isAlltypes }),
      );
    }
    const selectedData = options.filter((f) => f.select);
    const categoryIds = [];
    const typeIds = [];
    for (let i = 0; i < selectedData.length; i += 1) {
      const currentData = selectedData[i];
      if (!currentData.isSelectAll) {
        const selectedTypes = (currentData.types || [])
          .filter((f) => f.select)
          .map((e) => e.id);
        typeIds.push(...selectedTypes);
      } else {
        categoryIds.push(currentData.id);
      }
    }
    const param = {
      filing_categories_all: isAllCategories,
      filing_types_all: isAlltypes,
      filing_category_ids: categoryIds,
      filing_type_ids: typeIds,
    };
    propsFilterByCategory(param, token);
    if (piwikEnabled) {
      _paq.push(['trackEvent', 'Filings',
        `filling category id ${categoryIds}, filling type id ${typeIds}`]);
    }
  }

  sortOptions() {
    const {
      tabType, searchString, dropdown, typeOptions,
    } = this.state;
    const { options = [] } = dropdown;
    const lowerCaseSearchString = searchString.toLowerCase();
    if (tabType === 'types') {
      return typeOptions.filter((f) => f.name.toLowerCase().startsWith(lowerCaseSearchString));
    }
    return options.filter((f) => f.name.toLowerCase().startsWith(lowerCaseSearchString));
  }

  render() {
    const {
      isMenuOpen,
      tabType,
      selectedExpandRow,
      searchString,
      rightSideOptions,
      dropdownTitle,
      isAllCategories,
      isAlltypes,
      showLoading,
    } = this.state;

    const title = dropdownTitle || 'All Categories & Types';
    const filteredData = this.sortOptions();
    const isMainSelectAll = tabType === 'categories' ? isAllCategories : isAlltypes;

    return (
      <div
        id="filings_categories_dropdown"
        className={cx('filings-filter-btn', 'categories_dropdown')}
      >
        <Dropdown
          ref={(ref) => { this.categoriesDropdown = ref; }}
          show={isMenuOpen}
        >
          <Dropdown.Toggle onClick={this.handleDropdownHederClick}>
            <div className={Styles.categories_header}>
              <div className={Styles.header_holder}>
                <div className={Styles.main_header}>{title}</div>
                <div className={Styles.sub_header}>Category & Type</div>
              </div>
              <div className={Styles.header_icon}>
                <FontAwesomeIcon icon={isMenuOpen ? faChevronUp : faChevronDown} />
              </div>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu flip={false}>
            <div className="dropdown-items-wrapper">
              <div className="dropdown_title">
                Category & Type:
              </div>
              <FontAwesomeIcon className="dropdown_close" icon={faXmark} onClick={this.handleMenuCloseEvent} />
              <div className="dropdown_search">
                <FontAwesomeIcon icon={faSearch} />
                <input
                  type="text"
                  placeholder="Type to search..."
                  className="dropdown_search_input"
                  onChange={this.handleSearch}
                  value={searchString}
                />
              </div>
              <Dropdown.Divider />
              <div className="dropdown_tabs">
                <div
                  className={`dropdown_tab_label ${tabType === 'categories' ? 'active' : ''}`}
                  data-name="categories"
                  onClick={this.handleTabChangeClick}
                >
                  Categories
                </div>
                <div
                  className={`dropdown_tab_label ${tabType === 'types' ? 'active' : ''}`}
                  data-name="types"
                  onClick={this.handleTabChangeClick}
                >
                  Types
                </div>
              </div>
              <div className="dropdown_list_holder">
                {
                  !searchString
                    ? (
                      <Dropdown.Item eventKey="selectAll" active={isMainSelectAll} onSelect={this.handleSelectAllClick}>
                        <FontAwesomeIcon icon={isMainSelectAll ? faCheckSquare : faSquare} />
                        <span className="dropdown__checkbox_title select_all">Select / Unselect All</span>
                      </Dropdown.Item>
                    )
                    : null
                }
                <Preloader loading={showLoading} />
                {
                  tabType === 'types'
                    ? filteredData.map(({
                      id, name, category_id: categoryId, select,
                    }) => (
                      <DropdownRow
                        key={id}
                        categoryId={categoryId}
                        id={id}
                        name={name}
                        select={select}
                        handleRowSelect={this.handleTypeRowSelect}
                      />
                    ))
                    : filteredData.map(({
                      id, name, select, isSelectAll, types,
                    }) => (
                      <DropdownRow
                        showRightArrow
                        showArrow={!!types.length}
                        isRightSideMenuOpen={selectedExpandRow.id === id}
                        key={id}
                        isSelectAll={isSelectAll}
                        id={id}
                        name={name}
                        select={select}
                        handleRowSelect={this.handleParentCheckboxClick}
                        handleExpandRowSelect={this.handleExpandRowSelect}
                      />
                    ))
                }
              </div>
            </div>
          </Dropdown.Menu>
          {selectedExpandRow.id && (
            <div
              className="dropdown-menu dropdown-menu2 show"
            >
              <div className="dropdown-items-wrapper">
                <div className="dropdown_menu2_back">
                  <span onClick={this.handleMenuBackClickEvent}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                    Back
                  </span>
                </div>
                <FontAwesomeIcon className="dropdown_close" icon={faXmark} onClick={this.handleMenuCloseEvent} />
                <div className="dropdown_menu2_header">
                  {selectedExpandRow.name}
                  {' '}
                  Types
                </div>
                <div className="dropdown_menu2_list">
                  {
                    rightSideOptions.map(({ id, name, select }) => (
                      <DropdownRow
                        key={id}
                        id={id}
                        name={name}
                        select={select}
                        handleRowSelect={this.handleRowSelect}
                      />
                    ))
                  }
                </div>
              </div>
            </div>
          )}
        </Dropdown>
      </div>
    );
  }
}

const mapToStateProps = ({ watchlistReducer, storyFilters }) => ({
  token: watchlistReducer.userToken,
  filing_category_ids: storyFilters.filing_category_ids || [],
  filing_type_ids: storyFilters.filing_type_ids || [],
  isAllCategories: storyFilters.filing_categories_all,
  isAlltypes: storyFilters.filing_types_all,
});

const mapToDispatchProps = {
  fetchFilingsCategories,
  filterByCategory,
  filterByAllCategory,
};

export default withComponentName(
  connect(mapToStateProps, mapToDispatchProps)(CategoriesFilingsDropdown),
);
